"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorButtonRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colorPickerTheme = require("../../../../colorPickerTheme");
const ColorButtonRoot = (0, _styled.default)("button")`
    ${_ref => {
  let {
    addBorder,
    selected,
    themeMode
  } = _ref;
  return `
    width: ${_colorPickerTheme.colorPickerTheme.colorButton.size(themeMode)};
    height: ${_colorPickerTheme.colorPickerTheme.colorButton.size(themeMode)};
    border: ${addBorder ? `1px solid ${_colorPickerTheme.colorPickerTheme.colorButton.borderColor(themeMode)}` : "none"};
    box-sizing: border-box;
    border-radius: ${_colorPickerTheme.colorPickerTheme.colorButton.borderRadius(themeMode)};
    position: relative;
    display: inline-block;
    margin: ${_colorPickerTheme.colorPickerTheme.colorButton.margin(themeMode)};
    text-align: center;
    > span {
      display: unset;
    }
    > span > svg {
      width: ${_colorPickerTheme.colorPickerTheme.colorButton.svg.width(themeMode)};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }

    &:before {
      content:'';
      display: block;
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: ${_colorPickerTheme.colorPickerTheme.colorButton.before.size(themeMode)};
      height: ${_colorPickerTheme.colorPickerTheme.colorButton.before.size(themeMode)};
      border-radius: ${_colorPickerTheme.colorPickerTheme.colorButton.before.borderRadius(themeMode)};
      border-width: 2px;
      border-style: solid;
      border-color: ${selected ? _colorPickerTheme.colorPickerTheme.colorButton.before.color.selected(themeMode) : _colorPickerTheme.colorPickerTheme.colorButton.before.color.rest(themeMode)};
    }

    &:focus {
      outline: none;
    }
    
    &:hover:before {
      border-color: ${_colorPickerTheme.colorPickerTheme.colorButton.before.color.hover(themeMode)};
    }

    &:active:before {
      border-color: ${_colorPickerTheme.colorPickerTheme.colorButton.before.color.active(themeMode)};
    }

    &:focus:before {
      border-color: ${_colorPickerTheme.colorPickerTheme.colorButton.before.color.focus(themeMode)};
    }
  `;
}}
`;
exports.ColorButtonRoot = ColorButtonRoot;
//# sourceMappingURL=ColorButtonRoot.js.map